import { Label } from "@loot-os/ui/components/label";
import type { ReactNode } from "react";

/** One labelled control in a filter grid; `id` names the control the label points at. */
export function FilterField({
  id,
  label,
  className,
  children,
}: {
  id: string;
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={["grid gap-2", className].filter(Boolean).join(" ")}>
      <Label htmlFor={id}>{label}</Label>
      {children}
    </div>
  );
}
